module.exports = __webpack_public_path__ + "img/6.17cf3edf.png";